import { createSelector } from 'reselect';

const getUseFullViewportValue = (state) => state?.config?.useFullViewport;

export const getUseFullViewport = createSelector(
    [getUseFullViewportValue],
    (useFullViewport) => (useFullViewport)
);
